import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    // still checking
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-[#a1a1aa]"
      >
        <span className="font-mono-tech text-xs">Authenticating…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
